import {FC, useEffect, useRef} from 'react'

type Props = {
  isFetching: boolean
  totalRecords: number
  id?: string
  title?: string
  message?: string
  createRoute?: string
  createButton?: any
  buttonText?: string
  to?: string
  children: React.ReactNode
  isScrollToTop?: boolean
}

const AsyncListPage: FC<Props> = ({
  isFetching,
  totalRecords,
  isScrollToTop,
  children,
  ...props
}) => {
  const isLoaded = useRef(false)

  useEffect(() => {
    if (totalRecords > 0) {
      isLoaded.current = true
    }
  }, [totalRecords])

  useEffect(() => {
    if (isFetching && totalRecords && !isScrollToTop) {
      window.scrollTo({
        top: 50,
        behavior: 'smooth' || 'auto',
      })
    }
  }, [isFetching, totalRecords, isScrollToTop])

  if (isFetching && !isLoaded.current) {
    return (
      <div className='w-100 vh-75 d-flex justify-content-center align-items-center'>
        <label>
          <span className='indicator-progress d-block'>
            <span className='spinner-border align-middle ms-5 text-info'></span>
          </span>
          Loading...
        </label>
      </div>
    )
  }

  // if (totalRecords === 0 && !isLoaded.current) {
  //   return <NoRecords {...props} />
  // }

  return (
    <>
      <div>{children}</div>
      {isFetching && (
        <div className='position-absolute d-flex justify-content-center top-60 left-50 mx-20 px-10  '>
          <label>
            <span className='indicator-progress d-block'>
              <span className='spinner-border align-middle ms-5 text-info'></span>
            </span>
            Loading...
          </label>
        </div>
      )}
    </>
  )
}

export default AsyncListPage
